import { jwtDecode } from "jwt-decode";

// Utility function to check if token is expired
const isTokenExpired = (token) => {
    if (!token) return true; // If there's no token, treat it as expired.

    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Get the current time in seconds
        return decodedToken.exp < currentTime; // Compare expiration with current time
    } catch (error) {
        console.error("Invalid token", error);
        return true;
    }
};

// Common function to check token expiration and navigate
export const checkTokenAndNavigate = (token, navigate) => {
    if (isTokenExpired(token)) {
        navigate('/expire-invitation');
        localStorage.removeItem('authToken')
        return false
    } else {
        return true
    }
};
